export default [
    "26 26",
    '<rect x="0.5" y="0.5" rx="12.5" fill="none"/>\n' +
    '<rect x="0.5" y="0.5" rx="12.5" fill="none" stroke="#E1DFFB"/>\n' +
    '<path d="M16.75 9.25L9.25 16.75M9.25 9.25L16.75 16.75" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]